
import { Outlet, Link } from 'react-router-dom';
import ThemeToggle from './components/ThemeToggle';
import LanguageSwitcher from './components/LanguageSwitcher';
import { t, useLocale } from './i18n';

export default function App() {
    useLocale(); // rerender when locale changes
    return (
        <div className="min-h-dvh flex flex-col">
            <header className="sticky top-0 z-10 backdrop-blur bg-white/70 border-b border-slate-200">
                <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
                    <Link to="/" className="text-xl font-semibold">{t('app.brand')}</Link>
                    <div className="flex items-center gap-4">
                        <ThemeToggle />
                        <a href="https://scrumguides.org/" target="_blank" rel="noreferrer" className="text-slate-500 hover:text-slate-700 text-sm">
                            {t('app.scrumGuide')}
                        </a>
                        <LanguageSwitcher />
                    </div>
                </div>
            </header>
            <main className="flex-1">
                <div className="max-w-5xl mx-auto px-4 py-6">
                    <Outlet />
                </div>
            </main>
            <footer className="border-t border-slate-200">
                <div className="max-w-5xl mx-auto px-4 py-6 text-sm text-slate-500 flex flex-col gap-2 sm:flex-row sm:items-center">
                    <div className="flex-1">{t('app.footer', { year: new Date().getFullYear() })}</div>
                    <Link to="/impressum" className="text-slate-500 hover:text-slate-700 text-sm self-end sm:self-auto">
                        {t('app.imprint')}
                    </Link>
                </div>
            </footer>
        </div>
    );
}
